<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="main-row" *ngIf="!isInstaMed()">
  <div class="col-md-12">
    <fieldset>
      <legend class="row">
        <div class="col-md-6 m-auto">Merchant Address</div>
        <div class="col-md-6">
          <button
            class="btn btn-primary float-right"
            *ngIf="
              merchant.accountDetails.worldPayAccountDetails
                .backingWPMerchantExists &&
              isUserBase() &&
              isWorldPay() &&
              isMerchantActive() &&
              !editable
            "
            (click)="setEditable(true)"
          >
            <span>
              <fa-icon [icon]="faEditPencil"></fa-icon>
            </span>
            Edit Address
          </button>
        </div>
      </legend>
      <div class="mt-3" *ngIf="!editable">
        <app-merchant-address [merchant]="merchant"></app-merchant-address>
      </div>

      <div class="mt-3" *ngIf="editable">
        <form
          class="form-horizontal"
          novalidate
          [formGroup]="wpMerchantAddressForm"
          (submit)="updateMerchantAddress()"
        >
          <app-merchant-address-edit
            [parentGroup]="wpMerchantAddressForm"
            [merchantAddress]="this.merchantAddressFormGroup"
            [remitToAddress]="this.remitAddressFormGroup"
            [merchant]="merchant"
            (hasRemitAddress)="hasRemitEvent($event)"
          >
          </app-merchant-address-edit>
          <app-edit-buttons
            [buttonName]="buttonName"
            [actionInProgress]="actionInProgress"
            [formInvalid]="wpMerchantAddressForm.invalid"
            (editableEvent)="receiveEditEvent($event)"
          ></app-edit-buttons>
        </form>
      </div>
    </fieldset>
  </div>
</div>
